export const FILE_TYPE_JPG = 'jpg';
export const FILE_TYPE_JPEG = 'jpeg';
export const FILE_TYPE_PNG = 'png';
export const FILE_TYPE_GIF = 'gif';
export const FILE_TYPE_MP4 = 'mp4';
export const FILE_TYPE_MOV = 'mov';
export const FILE_TYPE_WMV = 'wmv';
export const FILE_TYPE_PDF = 'pdf';
export const FILE_TYPE_WORD_DOC = 'doc';
export const FILE_TYPE_WORD_DOCX = 'docx';
export const FILE_TYPE_EXCEL_XLS = 'xls';
export const FILE_TYPE_EXCEL_XLSX = 'xlsx';

export const CONTENT_TYPE_JPG_JPEG = 'image/jpeg';
export const CONTENT_TYPE_PNG = 'image/png';
export const CONTENT_TYPE_GIF = 'image/gif';
export const CONTENT_TYPE_PDF = 'application/pdf';
export const CONTENT_TYPE_WORD_DOC = 'application/msword';
export const CONTENT_TYPE_WORD_DOCX =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const CONTENT_TYPE_EXCEL_XLS = 'application/excel';
export const CONTENT_TYPE_EXCEL_XLSX =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const getFileSizeStr = (byteSize) => {
  const mbSize = 1024 * 1024;
  const kbyteSize = 1024;
  let sizeNumber;
  let strNumber;
  if (byteSize >= mbSize) {
    sizeNumber = byteSize / mbSize;
    strNumber = String(sizeNumber);
    if (strNumber.indexOf('.') > -1) {
      return Number(sizeNumber).toFixed(2) + 'MB';
    }
    return sizeNumber + 'MB';
  }
  if (byteSize >= kbyteSize) {
    sizeNumber = byteSize / kbyteSize;
    strNumber = String(sizeNumber);
    if (strNumber.indexOf('.') > -1) {
      return Number(sizeNumber).toFixed(2) + 'Kb';
    }
    return sizeNumber + 'Kb';
  }
  return byteSize + 'bytes';
};

export const loadBase64Image = (file) => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = (e) => {
      resolve(e.target.result);
    };
    reader.onerror = () => {
      reject();
    };
    reader.readAsDataURL(file);
  });
};

export const typeIsImage = (type) => {
  if (typeof type !== 'string') {
    return false;
  }
  switch (type.toLowerCase()) {
    case FILE_TYPE_JPG:
    case FILE_TYPE_JPEG:
    case FILE_TYPE_PNG:
    case FILE_TYPE_GIF:
      return true;
    default:
      return false;
  }
};

export const typeIsVideo = (type) => {
  if (typeof type !== 'string') {
    return false;
  }
  switch (type.toLowerCase()) {
    case FILE_TYPE_MP4:
    case FILE_TYPE_MOV:
    case FILE_TYPE_WMV:
      return true;
    default:
      return false;
  }
};

export const getFileBytesSize = (file) => {
  return file.size;
};

export const fileIsImage = (url) => {
  return typeIsImage(getFileType(url));
};

export const fileIsVideo = (url) => {
  return typeIsVideo(getFileType(url));
};

export const getFileType = (url) => {
  return url.substr(url.lastIndexOf('.') + 1);
};

export const getContentTypeByFileType = (type) => {
  switch (type.toLowerCase()) {
    case FILE_TYPE_JPG:
    case FILE_TYPE_JPEG:
      return CONTENT_TYPE_JPG_JPEG;
    case FILE_TYPE_PNG:
      return CONTENT_TYPE_PNG;
    case FILE_TYPE_GIF:
      return CONTENT_TYPE_GIF;
    case FILE_TYPE_PDF:
      return CONTENT_TYPE_PDF;
    case FILE_TYPE_WORD_DOC:
      return CONTENT_TYPE_WORD_DOC;
    case FILE_TYPE_WORD_DOCX:
      return CONTENT_TYPE_WORD_DOCX;
    case FILE_TYPE_EXCEL_XLS:
      return CONTENT_TYPE_EXCEL_XLS;
    case FILE_TYPE_EXCEL_XLSX:
      return CONTENT_TYPE_EXCEL_XLSX;
    default:
      return null;
  }
};

export const getContentTypeByUrl = (url) => {
  return getContentTypeByFileType(getFileType(url));
};

export const getFileNameEncoded = (fileName) => {
  return fileName.replace(/[^a-z0-9.]/gi, '_').toLowerCase();
};

export const hasLargeFile = (formData, maxSize) => {
  let largeFileFound  = false;
  Array.from(formData).forEach(([valor]) => {
    if (valor instanceof File && valor.size > maxSize) {
      largeFileFound  = true;
    }
  });
  return largeFileFound ;
};